import FormJaivana from 'dashboard_jaivana_v1';
/**
 *
 * @author Santiago_Hernandez
 * @updateBy Sebastian Rios Echverri
 * Versiones corregidas: 1.01.0054
 */
/**
 * Custom con funciones adicionales al formulario de correccion envasado produccion 
 **/
class CustomCorreccionEnvasado extends FormJaivana.form {
    constructor(props) {
        super(props);
        this.initForm                                       = this.initForm.bind(this);
        this.successDatosFicha                              = this.successDatosFicha.bind(this);
        this.successFichaEnvasadoFinal                      = this.successFichaEnvasadoFinal.bind(this);
        this.gridOptionsEnvasadoFinal                       = Object.assign({}, this.gridOptions);
        this.successFichaEnvasadoFinalMaterialEmpaque       = this.successFichaEnvasadoFinalMaterialEmpaque.bind(this)
        this.gridOptionsEnvasadoFinalMaterialEmpaque        = Object.assign({}, this.gridOptions);
        this.setButtonCantidadUtilizada                     = this.setButtonCantidadUtilizada.bind(this);
        this.cantidadUtilizadaChange                        = this.cantidadUtilizadaChange.bind(this);
        this.successCantidadUtilizada                       = this.successCantidadUtilizada.bind(this);
        this.uploadTbEnvasado                               = this.uploadTbEnvasado.bind(this);    
        this.setButtonCantUtilizada                         = this.setButtonCantUtilizada.bind(this);
        this.cantUtilizadaChange                            = this.cantUtilizadaChange.bind(this);
        this.successcantUtilizadaChange                     = this.successcantUtilizadaChange.bind(this);
        this.uploadTbEnvasadoMaterialEmpaque                = this.uploadTbEnvasadoMaterialEmpaque.bind(this);     
        this.abrirModalEnvasado                             = this.abrirModalEnvasado.bind(this);
        this.grabarEnvasado                                 = this.grabarEnvasado.bind(this);
        this.successGrabarEnvasado                          = this.successGrabarEnvasado.bind(this);
        this.abrirModalEnvasadoMatempaque                   = this.abrirModalEnvasadoMatempaque.bind(this);
        this.successDataProductos                           = this.successDataProductos.bind(this);
        this.grabarEnvasadoMatEmpaque                       = this.grabarEnvasadoMatEmpaque.bind(this);
        this.successGrabarEnvasadoMatEmpaque                = this.successGrabarEnvasadoMatEmpaque.bind(this);
        this.uploadDataSelectProductos                      = this.uploadDataSelectProductos.bind(this);
        this.successConceptoFicha                           = this.successConceptoFicha.bind(this);
        this.grabarTodo                                     = this.grabarTodo.bind(this);    
        this.successResumenAlistamiento                     = this.successResumenAlistamiento.bind(this);
        this.gridOptionsResumenAlistamiento                 = Object.assign({}, this.gridOptionsResumenAlistamiento);
        this.grabarTodoModalMatEmp                          = this.grabarTodoModalMatEmp.bind(this);
        this.successResumenEnvasadoFinal                    = this.successResumenEnvasadoFinal.bind(this);
        this.UploadResumenEnvasadoFinal                     = this.UploadResumenEnvasadoFinal.bind(this);
        this.cancelarModalMatEmpaque                        = this.cancelarModalMatEmpaque.bind(this);
        this.confirmItem                                    = this.confirmItem.bind(this);
        this.datosBodega                                    = this.datosBodega.bind(this);
        this.successtraerBodegasSelect                      = this.successtraerBodegasSelect.bind(this);
        this.arrayValidarCantidades = [];
        this.verFormula                                     = this.verFormula.bind(this);
        this.successVerFormula                              = this.successVerFormula.bind(this);
        this.gridOptionsVerFormula                          = Object.assign({}, this.gridOptions);
        this.successClose                                   = this.successClose.bind(this);
    }

    initForm(){
        console.log('Correccion de Envasado @version: 1.01.0054 @author: Mario A. @updateBy: Juan Nieto; @updateBy Sebastian Rios Echverri' )
        this.getField('btAgregarEnvasado').setClick(this.abrirModalEnvasado);
        this.getField('btnAgregarModalEnvasado').setClick(this.grabarEnvasado);
        this.getField('btAgregarEnvasadoMaterialEmpaque').setClick(this.abrirModalEnvasadoMatempaque);
        this.getField('btnAgregarModalEnvMatEmpaque').setClick(this.grabarEnvasadoMatEmpaque);
        this.getField('btnGrabar').setClick(this.grabarTodo);
        this.getField('btnConfirmar').setClick(this.grabarTodoModalMatEmp);
        this.getField('btnCancelar').setClick(this.cancelarModalMatEmpaque);

        this.getField('textoConfiguracionEnvasado').setValue('CONFIGURACIÓN ENVASADO');

        this.getField('articulo_id_nofabricado').setOnChange(this.datosBodega);

        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'conceptoficha', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successConceptoFicha,
            error: this.error_,
            general: this.generalFormatPmv
        });

        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'iddatos', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successDatosFicha,
            error: this.error_,
            general: this.generalFormatPmv
        });

        this.generalFormatPmv = { tipo_servicio: 'prod-fichasenvasadofinalmaterial', operacion: 'fichaid', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successFichaEnvasadoFinalMaterialEmpaque,
            error: this.error_,
            general: this.generalFormatPmv
        });

        let datos2 = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-correccionenvasado', operacion: 'fichaid', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos2,
            success: this.successFichaEnvasadoFinal,
            error: this.error_,
            general: this.generalFormatPmv
        });

        this.generalFormatPmv = { tipo_servicio: 'prod-correccionenvasado', operacion: 'resumenenvasado', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos2,
            success: this.successResumenEnvasadoFinal,
            error: this.error_,
            general: this.generalFormatPmv
        });

        this.getField('btn_verformula').setClick(this.verFormula);
    }

    verFormula(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'verformula', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successVerFormula,
            error: this.error_,
            showMessage: false,
            general: this.generalFormatPmv
        });
    }

    successVerFormula(data){
        if (data.estado_p === 200 && data.data.length >= 1) {
            this.getField('modal_verformula').handleClickOpen();
            this.getField('tb_verformula').toggle(true);
            this.gridOptionsVerFormula['rowData'] = data.data;
            let configCell = new Map();
            configCell.set('nombre_articulo',{headerName: 'Nombre Artículo'});
            configCell.set('version',{headerName: 'Versión'});
            configCell.set('produccion_formulas_versiones',{headerName: 'Producción Fórmulas Versiones'});
            configCell.set('estado_descripcion',{headerName: 'Estado Descripción'});
            this.getField('tb_verformula').initData(this.gridOptionsVerFormula, configCell);
        }else if (data.estado_p === 404){
            this.alertGeneral.toggle(true,'No hay datos',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }else{
            this.alertGeneral.toggle(true,'Error al consumir el servicio.',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }
    }
    
    datosBodega(){
        if (this.getField('articulo_id_nofabricado').getValue() !== '' && this.getField('articulo_id_nofabricado').getValue() !== ' ') {
            let datos = {
                datos:{
                    value: this.getField('articulo_id_nofabricado').getValue(),
                }
            }

            this.generalFormatPmv = { tipo_servicio: 'prod-articulo', operacion: 'saldobodegas', operacion_tipo: 'consulta' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.successtraerBodegasSelect,
                error: this.error_,
                general: this.generalFormatPmv
            });
            /*this.generalFormat.nombre_accion = '446-Trae_el_saldo_referente_al_producto_para_el_select_de_bodegas';
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: body,
                    success: this.successtraerBodegasSelect,
                    error: this.error_,
                    general: this.generalFormat
                });*/
        }
    }

    successtraerBodegasSelect(data){
        let opciones = [{
            'text':'Ninguno',
            'value':'',
            'campos_cambian':{}
        }];
        if (data.estado_p === 200) {
           
            data.data.forEach(item => {
                let dataOp = {}
                dataOp['value'] = item.id;
                dataOp['text'] = `${item.nombre_bodega} , saldo = ${item.saldo}`;
                dataOp['campos_cambian'] = {codigo_bodega_cod : item.codigo_bodega};
                opciones.push(dataOp);
            })
            this.getField('codigo_bodega').setOptions(opciones);
        }else{
            this.getField('codigo_bodega').setOptions(opciones);
        }
    }

    successResumenEnvasadoFinal(data){
        //data.data[0].total_envasado <= data.data[0].galones_resultantes  <-- Antes se permitia que fuera menor, por solicitud de pintunal solo se permite si son iguales 04/04/2022
        if(data.data[0].total_envasado !== data.data[0].galones_resultantes ){
        this.getField('btnGrabar').setDisabled(false);
        this.getField('confirmModalCustom').setTitleAndContent('Alerta','Total envasado no es igual que galones resultantes');
        this.getField('confirmModalCustom').setClickDialog(this.confirmItem);//funcion que se ejecuta al confirmar mensaje
        this.getField('confirmModalCustom').toggle(true);
        data.data[0].total_envasado < data.data[0].galones_resultantes?this.getField('btnGrabar').setDisabled(true):this.getField('btnGrabar').setDisabled(false);
        }        
        this.getField('galones_resultantes1').setValue(data.data[0].galones_resultantes);
        this.getField('total_envasado').setValue(data.data[0].total_envasado);
        this.getField('restante1').setValue(data.data[0].restante);
        data.data[0].total_envasado < data.data[0].galones_resultantes?this.getField('btnGrabar').setDisabled(true):this.getField('btnGrabar').setDisabled(false);

    }

    confirmItem(){
        this.getField('confirmModalCustom').toggle(false);
    }

    UploadResumenEnvasadoFinal(){
        let datos = {
            datos: {
                value: this.props.data.id_ficha, 
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-correccionenvasado', operacion: 'resumenenvasado', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successResumenEnvasadoFinal,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '446-Retorna_el_resumen_del_envasado_final'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:body,
                success:this.successResumenEnvasadoFinal,
                error:this.error_,
                general: this.generalFormat
            });*/
    }


    successConceptoFicha(data){
        if (data.estado_p === 200 && data.data !== undefined && data.data.length > 0){
            this.getField('listaConceptosFicha').setValue(data.data[0].descripcion);
        }
    }

    successDataProductos(data){
        
    }

    uploadDataSelectProductos(){
        /*this.generalFormat.nombre_accion = '446-Retorna_el_envasado_final_ordenados por_nombre_del_producto'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:body,
                success:this.successDataProductos,
                error:this.error_,
                general: this.generalFormat
            });*/
    }

    successDatosFicha(data){
        if (data.estado_p === 200 && data.data !== undefined && data.data.length > 0){
            this.getField('lista_items_produccion').setVisible(true);
            this.getField('lista_items_produccion').setItemsFichas(data.data);
        }else{
            this.getField('lista_items_produccion').setVisible(false);
        }
    }

    successFichaEnvasadoFinal(data){
        if (data.estado_p === 200 && data.data !== undefined && data.data.length > 0) 
        {
            let opciones = [{
                'text':'Ninguno',
                'value':'',
                'campos_cambian':{}
            }];
            if (data.estado_p === 200) {
            
                data.data.forEach(item => {
                    let dataOp = {}
                    dataOp['value'] = item.id;
                    dataOp['text'] = item.codigo + "  " + item.nombre;;
                    dataOp['campos_cambian'] = {produccion_fichas_envasado_final_id : item.id};
                    opciones.push(dataOp);
                })
                this.getField('producto').setOptions(opciones);
            }else{
                this.getField('producto').setOptions(opciones);
            }
            this.gridOptionsEnvasadoFinal['rowData']=[];
            this.getField('TbEnvasadoInicio').initData(this.gridOptionsEnvasadoFinal);
            let configCell = new Map();
            configCell.set('cantidad_utilizada',{cellRenderer:this.setButtonCantidadUtilizada,cellStyle: {backgroundColor: "rgb(238,238,238)",textAlign:"right",borderRadius:"5px",color:'rgb(0, 86, 201)'}, onCellValueChanged:this.cantidadUtilizadaChange,width:100, editable: true, field: 'cantidad_utilizada' });
            this.getField('TbEnvasadoInicio').toggle(true);
            this.gridOptionsEnvasadoFinal['rowData'] = data.data;
            this.gridOptionsEnvasadoFinal.paginationPageSize = 100;
            this.getField('TbEnvasadoInicio').initData(this.gridOptionsEnvasadoFinal, configCell);

        }else{ 
          this.getField('TbEnvasadoInicio').toggle(false);
          this.getField('fieldAlert').toggle(true,"No hay envasado","error");
        } 
    }

    setButtonCantidadUtilizada(props){
        let valor_actual = props.data.cantidad_utilizada;
        let div = document.createElement("div");
        let label = document.createElement("label");
        if(valor_actual !== null && valor_actual !== '' && valor_actual !== undefined && valor_actual >= 0 ){
            label.textContent = valor_actual;
            return "".formatoPrecio(props.data.cantidad_utilizada); // se pone el formato precio a los datos editados en descuento
        }   
        else{
            label.textContent = 0;
        div.appendChild(label);
        return this.createElementJaivana(div);
        }
    }

    cantidadUtilizadaChange(props){
        let seguir = this.getField('TbEnvasadoInicio').cellValid(props.oldValue,props.newValue,'^[0-9]'); // Se valida que el dato ingresado sea un numero
        if (props.newValue < 0 ){
            props.data.cantidad_utilizada = 0;
        }
        if(seguir){

            this.getField('cantidad_utilizada').setValue(props.newValue);
            
            let datos = {
                datos:{
                    id: props.data.id,
                    cantidad_utilizada: this.getField('cantidad_utilizada').getValue(),
                    actividad_id:this.props.data.actividad_id
                }
            }

            this.generalFormatPmv = { tipo_servicio: 'prod-correccionenvasado', operacion: 'cantidadutilizada', operacion_tipo: 'modificar' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'PUT',
                body: datos,
                success: this.successCantidadUtilizada,
                error: this.error_,
                general: this.generalFormatPmv
            });
            /*this.generalFormat.nombre_accion = '446-Permite_cambiar_la_cantidad_utilizada'; 
            this.service.send(
                {
                    endpoint:this.constant.formConfiguration(),
                    method:'PUT',
                    body:body,
                    success:this.successCantidadUtilizada,
                    error:this.error_,
                    general: this.generalFormat
                });*/
        }
    }

    successCantidadUtilizada(response){
        if (response.estado_p === 200) {
            this.getField('cantidad_utilizada').setValue(' ');
            this.uploadTbEnvasado();
            this.UploadResumenEnvasadoFinal();
            this.uploadTbEnvasadoMaterialEmpaque();
        }
    }

    uploadTbEnvasado(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha, 
            }
        }
        // produccion_fichas_envasado_final-fichaid
        this.generalFormatPmv = { tipo_servicio: 'prod-correccionenvasado', operacion: 'fichaid', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successFichaEnvasadoFinal,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*
        this.generalFormat.nombre_accion = '446-Retorna_las_fichas_envasado_final'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:body,
                success:this.successFichaEnvasadoFinal,
                error:this.error_,
                general: this.generalFormat
            });*/
    }

    successFichaEnvasadoFinalMaterialEmpaque(data){
        if (data.estado_p === 200 && data.data !== undefined && data.data.length > 0){
            this.gridOptionsEnvasadoFinalMaterialEmpaque['rowData']=[];
            this.getField('TbEnvasadoFinal').initData(this.gridOptionsEnvasadoFinalMaterialEmpaque);
            let configCell = new Map();
            configCell.set('cantidad_utilizada',{cellRenderer:this.setButtonCantUtilizada,cellStyle: {backgroundColor: "rgb(238,238,238)",textAlign:"right",borderRadius:"5px",color:'rgb(0, 86, 201)'}, onCellValueChanged:this.cantUtilizadaChange,width:100, editable: true, field: 'cantidad_utilizada' });
            this.getField('TbEnvasadoFinal').toggle(true);
            this.gridOptionsEnvasadoFinalMaterialEmpaque['rowData'] = data.data;
            this.gridOptionsEnvasadoFinalMaterialEmpaque.paginationPageSize = 100;
            this.getField('TbEnvasadoFinal').initData(this.gridOptionsEnvasadoFinalMaterialEmpaque, configCell);
            this.arrayValidarCantidades = data.data;
        }else{ 
          this.getField('TbEnvasadoFinal').toggle(false);
          this.getField('fieldAlert').toggle(true,"No hay envasado","error");
        } 
    }

    setButtonCantUtilizada(props){
        let valor_actual = props.data.cantidad_utilizada;
        let div = document.createElement("div");
        let label = document.createElement("label");
        if(valor_actual !== null && valor_actual !== '' && valor_actual !== undefined && valor_actual >= 0 ){
            label.textContent = valor_actual;
            return "".formatoPrecio(props.data.cantidad_utilizada); // se pone el formato precio a los datos editados en descuento
        }   
        else{
            label.textContent = 0;
        div.appendChild(label);
        return this.createElementJaivana(div);
        }
    }

    cantUtilizadaChange(props){
        let seguir = this.getField('TbEnvasadoFinal').cellValid(props.oldValue,props.newValue,/^[0-9]+$/); // Se valida que el dato ingresado sea un numero
        if (props.newValue < 0 ){
            props.data.cantidad_utilizada = 0;
        }
        if(seguir){

            this.getField('cantidad_utilizada_matEmp').setValue(props.newValue);
            let datos = {
                datos:{
                    id: props.data.id,
                    cantidad_utilizada: this.getField('cantidad_utilizada_matEmp').getValue(),
                    actividad_id:this.props.data.actividad_id
                }
            }

            this.generalFormatPmv = { tipo_servicio: 'prod-fichasenvasadofinalmaterial', operacion: 'cantidadutilizada', operacion_tipo: 'modificar' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'PUT',
                body: datos,
                success: this.successcantUtilizadaChange,
                error: this.error_,
                general: this.generalFormatPmv
            });
            /*this.generalFormat.nombre_accion = '446-Permite_cambiar_la_cantidad_utilizada_MatEmpaque'; 
            this.service.send(
                {
                    endpoint:this.constant.formConfiguration(),
                    method:'PUT',
                    body:body,
                    success:this.successcantUtilizadaChange,
                    error:this.error_,
                    general: this.generalFormat
                });*/
        }else{
            this.uploadTbEnvasadoMaterialEmpaque();
        }
    }

    successcantUtilizadaChange(response){
        if (response.estado_p === 200) {
            this.getField('cantidad_utilizada_matEmp').setValue(' ');
            this.uploadTbEnvasadoMaterialEmpaque();
        }
    }

    uploadTbEnvasadoMaterialEmpaque(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha, 
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-fichasenvasadofinalmaterial', operacion: 'fichaid', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successFichaEnvasadoFinalMaterialEmpaque,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '446-Retorna_las_fichas_envasado_final_material_empaque'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:body,
                success:this.successFichaEnvasadoFinalMaterialEmpaque,
                error:this.error_,
                general: this.generalFormat
            });*/
    }

    abrirModalEnvasado(){
        this.getField('modalEnvasado').handleClickOpen();
        this.getField('produccion_fichas_id').setValue(this.props.data.id_ficha);
        this.getField('produccion_kit_id').setValue('');
        this.getField('codigo_producto').setValue('');
        this.getField('nombre_producto').setValue('');
        this.getField('factor').setValue('');
        this.getField('codigo_kit').setValue('');
        this.getField('descripcion').setValue('');
        this.getField('articulo_id').setValue('');
        this.getField('es_envasado_id').setValue('');
    }

    grabarEnvasado(){
        if(this.getField('cantidad').getValue() !== '' && this.getField('cantidad').getValue() !== ' '){
            this.getField('cantidad').setError(false,"");
            let datos = {}
            if(this.getField('produccion_kit_id').getValue() !== '' && this.getField('produccion_kit_id').getValue() !== ' '){
                datos = {
                    datos:{
                        produccion_fichas_id:this.props.data.id_ficha,
                        articulo_id:this.getField('articulo_id').getValue(),
                        cantidad:this.getField('cantidad').getValue(),
                        produccion_kit_id:this.getField('produccion_kit_id').getValue(),
                        actividad_id:this.props.data.actividad_id
                    }
                }
            }else {
                datos = {
                    datos:{
                        produccion_fichas_id:this.props.data.id_ficha,
                        articulo_id:this.getField('articulo_id').getValue(),
                        cantidad:this.getField('cantidad').getValue(),
                        actividad_id:this.props.data.actividad_id
                    }
                }
            }
            this.generalFormatPmv = { tipo_servicio: 'prod-correccionenvasado', operacion: 'crear', operacion_tipo: 'consulta' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'POST',
                body: datos,
                success: this.successGrabarEnvasado,
                error: this.error_,
                general: this.generalFormatPmv
            });
        }else{
            if(this.getField('cantidad').valid() && this.getField('cantidad').getValue() === '' ){
                this.getField('cantidad').setError(true,"Este campo es requerido");
            }
        }
    }

    successGrabarEnvasado(response){
        if(response.estado_p === 200){
            this.getField('fieldAlert').toggle(true,"Ficha envasado creada exitosamente","success");
            this.getField('modalEnvasado').handleClose();
            this.uploadTbEnvasado();
            this.uploadTbEnvasadoMaterialEmpaque();
            this.UploadResumenEnvasadoFinal();
            

        }else{
            this.getField('fieldAlert').toggle(true,"La ficha envasado no pudo ser creada","error");
        }
        this.getField('btnConfirmar').setDisabled(false);
    }

    abrirModalEnvasadoMatempaque(){
        this.getField('codigo_bodega').setError(false,"");
        this.getField('modalEnvasadoMaterialEmpaque').handleClickOpen();
        this.getField('codigo_producto_nofabricado').setValue('');
        this.getField('nombre_producto_nofabricado').setValue('');
        this.getField('articulo_id_nofabricado').setValue('');
        this.getField('cantidadEnvMatEmpaque').setValue('');
    }

    grabarEnvasadoMatEmpaque(){
        if(this.getField('codigo_producto_nofabricado').getValue() !== '' && this.getField('codigo_producto_nofabricado').getValue() !== ' ' &&
            this.getField('nombre_producto_nofabricado').getValue() !== '' && this.getField('nombre_producto_nofabricado').getValue() !== ' ' &&
            this.getField('cantidadEnvMatEmpaque').getValue() !== '' && this.getField('cantidadEnvMatEmpaque').valid() &&
            this.getField('producto').getValue() !== '' && this.getField('producto').getValue() !== ' '  && 
            this.getField('codigo_bodega_cod').getValue() !== '19'){

            this.getField('codigo_producto_nofabricado').setError(false,"");
            this.getField('nombre_producto_nofabricado').setError(false,"");
            this.getField('cantidadEnvMatEmpaque').setError(false,"");
            this.getField('producto').setError(false,"");
            
            let datos = {
                datos:{
                    produccion_fichas_id:this.props.data.id_ficha,
                    articulo_id:this.getField('articulo_id_nofabricado').getValue(),
                    cantidad_utilizada:this.getField('cantidadEnvMatEmpaque').getValue(),
                    produccion_fichas_envasado_final_id:this.getField('produccion_fichas_envasado_final_id').getValue(),
                    codigo_bodega: this.getField('codigo_bodega_cod').getValue(),
                    actividad_id:this.props.data.actividad_id
                }
            }

            this.generalFormatPmv = { tipo_servicio: 'prod-fichasenvasadofinalmaterial', operacion: 'crear', operacion_tipo: 'crear' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'POST',
                body: datos,
                success: this.successGrabarEnvasadoMatEmpaque,
                error: this.error_,
                general: this.generalFormatPmv
            });
            /*this.generalFormat.nombre_accion = "446-Permite_crear_un_envasado_final_material_empaque"; 
            this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'POST',
                body:body,
                success:this.successGrabarEnvasadoMatEmpaque,
                error:this.error_,
                general: this.generalFormat
            });*/
        }else{
            if(this.getField('codigo_producto_nofabricado').valid() && this.getField('codigo_producto_nofabricado').getValue() === '' ){
                this.getField('codigo_producto_nofabricado').setError(true,"Este campo es requerido");
            }
            if(this.getField('nombre_producto_nofabricado').valid() && this.getField('nombre_producto_nofabricado').getValue() === '' ){
                this.getField('nombre_producto_nofabricado').setError(true,"Este campo es requerido");
            }
            if(this.getField('cantidadEnvMatEmpaque').valid() && this.getField('cantidadEnvMatEmpaque').getValue() === '' ){
                this.getField('cantidadEnvMatEmpaque').setError(true,"Este campo es requerido");
            }
            if(this.getField('producto').valid() && this.getField('producto').getValue() === '' ){
                this.getField('producto').setError(true,"Este campo es requerido");
            }
            if(this.getField('codigo_bodega_cod').getValue() === '19'){
                this.getField('codigo_bodega').setError(true,"No se puede tomar este producto de la bodega 19");
            }
        }
    }

    successGrabarEnvasadoMatEmpaque(response){
        if(response.estado_p === 200){
            this.getField('fieldAlert').toggle(true,"Ficha envasado creada exitosamente","success");
            this.getField('modalEnvasadoMaterialEmpaque').handleClose();
            this.uploadTbEnvasadoMaterialEmpaque();
        }else{
            this.getField('fieldAlert').toggle(true,"La ficha envasado no pudo ser creada","error");
        }
        this.getField('btnConfirmar').setDisabled(false);
    }

    grabarTodo(){
        let seguir = true
        this.arrayValidarCantidades.map((item, i)=>{
            if (this.arrayValidarCantidades[i].cantidad_utilizada - Math.floor(this.arrayValidarCantidades[i].cantidad_utilizada) !== 0) {
                this.alertGeneral.toggle(true,`El campo Cantidad Utilizada para el material de empaque ${item.codigo} (${item.cantidad_utilizada}) debe ser entero`,"error");
                seguir = false;
            }
            return null;
        });        
        if(seguir){
            this.getField('btnGrabar').setDisabled(true);
            this.getField('modalResumenAlistamiento').handleClickOpen();
            this.getField('txt_resumen_alistamiento').setValue('Se generará un alistamiento para:');
            let datos = {
                datos:{
                    value: this.props.data.id_ficha, 
                }
            }

            this.generalFormatPmv = { tipo_servicio: 'prod-fichasenvasadofinalmaterial', operacion: 'resumenalistamiento', operacion_tipo: 'consulta' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.successResumenAlistamiento,
                error: this.error_,
                general: this.generalFormatPmv
            });
            /*this.generalFormat.nombre_accion = '446-Retorna_resumen_de_alistamiento'; 
            this.service.send(
                {
                    endpoint:this.constant.formConfiguration(),
                    method:'GET',
                    body:body,
                    success:this.successResumenAlistamiento,
                    error:this.error_,
                    general: this.generalFormat
                });*/
        }
        
    }

    successResumenAlistamiento(data){
        if (data.estado_p === 200 && data.data !== undefined && data.data.length > 0) 
        {
            this.gridOptionsResumenAlistamiento['rowData']=[];
            this.getField('tbResumenAlistamiento').initData(this.gridOptionsResumenAlistamiento);
           
            this.getField('tbResumenAlistamiento').toggle(true);
            this.gridOptionsResumenAlistamiento['rowData'] = data.data;
            this.gridOptionsResumenAlistamiento.paginationPageSize = 100;
            this.getField('tbResumenAlistamiento').initData(this.gridOptionsResumenAlistamiento);
            this.getField('btnGrabar').setDisabled(false);
        }else{ 
          this.getField('tbResumenAlistamiento').toggle(false);
          this.getField('modalResumenAlistamiento').handleClose();
            if(data.estado_p === 404){
                this.grabarTodoModalMatEmp();
            }else{
                this.getField('btnGrabar').setDisabled(false);
            }
        }
    }

    grabarTodoModalMatEmp(){
        this.getField('produccion_fichas_id').setValue(this.props.data.id_ficha);
        this.getField('proceso_id').setValue(this.props.data.proceso_id);
        this.getField('actividad_id').setValue(this.props.data.actividad_id);
        this.getField('actividad_configuracion_id').setValue(this.props.data.actividad_configuracion_id);
        this.getField('btnConfirmar').setDisabled(true);
        let datos = {
            datos:{
                id_formulario: this.formId,
                produccion_fichas_id:this.getField('produccion_fichas_id').getValue(),
                proceso_id:this.getField('proceso_id').getValue(),
                actividad_id:this.getField('actividad_id').getValue(),
                actividad_configuracion_id:this.getField('actividad_configuracion_id').getValue(),
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-correccionenvasado', operacion: 'grabar', operacion_tipo: 'crear' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'POST',
            body: datos,
            success: this.successClose,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = "446-Permite_pasar_a_la_actividad_de_alistamiento_envasado_final"; 
        this.service.send(
        {
            endpoint:this.constant.formConfiguration(),
            method:'POST',
            body:body,
            success:this.successCloseEstage,
            error:this.error_,
            general: this.generalFormat
        });*/
    }

    successClose(data){
        this.getField('btnConfirmar').setDisabled(false);
        this.getField('btnGrabar').setDisabled(false);
        if(data.estado_p === 200){
            this.successCloseEstage(data);
        }
    }

    cancelarModalMatEmpaque(){
        this.getField('btnGrabar').setDisabled(false);
        this.getField('modalResumenAlistamiento').handleClose();
    }
}
FormJaivana.addController("prod-correccionenvasado",CustomCorreccionEnvasado);
export default CustomCorreccionEnvasado;